/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Suggest_Ask_OverlapsInputs */



/**
* | output |
* | --- |
* | "How do I fix overlapping subtitles?" |
*
* @param {Assistant_Suggest_Ask_OverlapsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_suggest_ask_overlaps = /** @type {((inputs?: Assistant_Suggest_Ask_OverlapsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Suggest_Ask_OverlapsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment puis-je corriger le chevauchement des sous-titres ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie kann ich überlappende Untertitel beheben?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come posso risolvere il problema dei sottotitoli sovrapposti?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Как исправить проблему с наложением субтитлов?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cómo soluciono el problema de los subtítulos superpuestos?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("如何解决字幕重叠问题？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕の重なりを修正するにはどうすればよいですか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरलैप हो रहे सबटाइटल्स को मैं कैसे ठीक करूं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Como faço para corrigir legendas sobrepostas?")
	return /** @type {LocalizedString} */ ("How do I fix overlapping subtitles?")
});